
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ContainerDefault from '../../components/ContainerDefault';
import * as agricultorAction from '../../services/agricultor/Action';
import * as Constants from '../../utils/constants';
import Table from './components/Table';
import TablePessoa from '../pessoa/components/TablePessoa';
import { Loading } from '../../components/UtilComponent';
import Swal from 'sweetalert2';


class Index extends Component {

  constructor() {
    super()

    this.state = {
      checked: false
    };
  }


  componentDidMount() {
    this.props.action.getAgricultoresAction(!this.state.checked);
  }

  handleChange = event => {
    this.setState({
    });
  };

  handleClick = (event, id) => {
    console.log(id);
  };

  handleClickTodos = () => {
    this.setState({ checked: !this.state.checked });

    this.props.action.getAgricultoresAction(this.state.checked);
  }

  handleClickDelete = (id, nome) => {
    Swal.fire({
      title: `${!this.state.checked ? 'Excluir' : 'Ativar'} item?`,
      text: `Você realmente deseja ${!this.state.checked ? 'excluir' : 'ativar'} o cliente  ${nome} ? `,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showLoaderOnConfirm: true,
      confirmButtonText: `Sim, ${!this.state.checked ? 'excluir' : 'ativar'} esse cliente!`,
      preConfirm: async (willDelete) => {
        try {
          await this.props.action.desativarOrAtivarAgricultorByIdAction(id, this.state.checked);
          await this.props.action.getAgricultoresAction(!this.state.checked);
          return 'ok'
        } catch (err) {
          throw err;
        }
      },
      dangerMode: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          text: "Operação realizada com sucesso!",
          icon: "success",
        });
      } else {
        Swal.fire({
          text: "Operação cancelada!",
          icon: "info",
        });
      }
    }).catch(err => {
      if (err) {
        Swal.fire({
          text: `Operação cancelada! ${err['detail'] ? err['detail'] : ''}`,
          icon: "error",
        });
      } else {
        Swal.stopLoading();
        Swal.close();
      }
    });
  }
  retornarDadosTela() {
    const { agricultorObject, messages, isLoading } = this.props;


    if (agricultorObject === null && isLoading)
      return <Loading title={Constants.DESCRICAO_AGRICULTORES} />

    return (<ContainerDefault
      title={Constants.DESCRICAO_AGRICULTORES}
      url={Constants.ROUTE_URL_AGRICULTOR}
      messages={messages}
      button={Constants.DESCRICAO_NOVO}
      container={<TablePessoa pessoaObject={agricultorObject ? agricultorObject : []}
        edit_url={Constants.ROUTE_URL_AGRICULTOR}
        handleClickDelete={this.handleClickDelete}
        handleClickTodos={this.handleClickTodos}
        checked={this.state.checked}
      />}
    />);

  }

  render() {
    return this.retornarDadosTela();
  }
}

Index.propTypes = {
};

const mapStateToProps = state => ({
  agricultorObject: state.agricultorReducer.agricultorObject,
  messages: state.messageResponseReducer.messages,
  isLoading: state.apiReducer.isLoading
});

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators(agricultorAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
